import { render, staticRenderFns } from "./SettingsSectionCard.vue?vue&type=template&id=e7366b98&scoped=true"
import script from "./SettingsSectionCard.vue?vue&type=script&lang=js"
export * from "./SettingsSectionCard.vue?vue&type=script&lang=js"
import style0 from "./SettingsSectionCard.vue?vue&type=style&index=0&id=e7366b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7366b98",
  null
  
)

export default component.exports